<template>
    <div ref="notificationRef" class="notification">
        <div v-if="this.$store.state.notification.type === 'success'">
            <Icon :name="'check-green'" />
        </div>
        <div class="text-black text-nowrap">
            {{ this.$store.state.notification.text }}
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue'

export default {
    components: {
        Icon
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit('NOTIFICATION', {
                type: false,
                text: false
            })
        }, 3000)
    },
}
</script>

<style lang="scss" scoped>
.notification {
    position: fixed;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    background-color: white;
    padding: 16px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 20000;
}
</style>